import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyEndTime: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.connected-time-pickers.end.empty-end-time',
		defaultMessage: 'End time must not be empty',
		description: 'error message displayed when end time is empty',
	},
	invalidEndTime: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.connected-time-pickers.end.invalid-end-time',
		defaultMessage: 'End time must be valid time',
		description: 'error message displayed when end time is invalid',
	},
	endTime: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.connected-time-pickers.end.end-time',
		defaultMessage:
			'Finish time currently set as {time}. Select to define a different finish time for {day}.',
		description: 'Aria label for end time',
	},
});
